<script setup lang="ts">
import { BButton } from 'bootstrap-vue-next';
import type { Ref } from 'vue';
import { ref, computed } from 'vue';

import PajamasCopyToClipboard from '~icons/pajamas/copy-to-clipboard';
import PajamasReviewCheckmark from '~icons/pajamas/review-checkmark';
import SimpleIconsBluesky from '~icons/simple-icons/bluesky';
import SimpleIconsMastodon from '~icons/simple-icons/mastodon';
import SimpleIconsX from '~icons/simple-icons/x';

const props = defineProps<{
  text: string;
  url: string;
}>();

const twitterUrl = computed(
  () => `https://x.com/intent/tweet?${new URLSearchParams({ text: props.text, url: props.url })}`,
);
const blueskyUrl = computed(
  () => `https://bsky.app/intent/compose?text=${encodeURIComponent(`${props.text} ${props.url}`)}`,
);
const mastodonUrl = computed(
  () => `https://share.joinmastodon.org/?text=${encodeURIComponent(`${props.text} ${props.url}`)}`,
);

const copied = ref(false);

const copyToClipboard = async (data: string) => {
  await navigator.clipboard.writeText(data);
};

const setTempFlag = (reference: Ref<boolean>) => {
  reference.value = true;
  setTimeout(() => {
    reference.value = false;
  }, 2000);
};

const copyLink = async () => {
  await copyToClipboard(`${props.text} ${props.url}`);
  setTempFlag(copied);
};
</script>

<template>
  <div class="d-flex gap-2 flex-wrap">
    <BButton
      variant="outline-secondary"
      size="sm"
      :href="twitterUrl"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Share on X"
    >
      <SimpleIconsX class="me-1" /> X (Twitter)
    </BButton>
    <BButton
      variant="outline-secondary"
      size="sm"
      :href="blueskyUrl"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Share on Bluesky"
    >
      <SimpleIconsBluesky class="me-1" /> Bluesky
    </BButton>
    <BButton
      variant="outline-secondary"
      size="sm"
      :href="mastodonUrl"
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Share on Mastodon"
    >
      <SimpleIconsMastodon class="me-1" /> Mastodon
    </BButton>
    <BButton
      variant="outline-secondary"
      size="sm"
      aria-label="Copy link"
      @click="copyLink"
    >
      <PajamasReviewCheckmark
        v-if="copied"
        class="me-1"
      />
      <PajamasCopyToClipboard
        v-else
        class="me-1"
      />
      Copy link
    </BButton>
  </div>
</template>
